import axios from 'axios'

export default {
  async createLicenseRecovery (data) {
    return axios.post('/api/v1/license-recovery', data)
  }
}
